<template>
  <div class="popup" v-if="isVisible && filteredPopupData.length > 0">
    <div class="popup-inner">
      <!-- 이미지 영역 (url이 있으면 a 태그, 없으면 div) -->
      <component
        :is="currentPopup.url ? 'a' : 'div'"
        :href="currentPopup.url || undefined"
        :target="currentPopup.url ? '_blank' : undefined"
        class="img-wrap"
      >
        <img :src="currentPopup.attachment.download_url" alt="popup image" />
        <!-- 좌우 화살표 (2개 이상일 때만) -->
        <template v-if="filteredPopupData.length > 1">
          <button type="button" class="arrow-btn arrow-left" @click.prevent="prev">
            <span class="arrow-icon arrow-prev"></span>
          </button>
          <button type="button" class="arrow-btn arrow-right" @click.prevent="next">
            <span class="arrow-icon arrow-next"></span>
          </button>
        </template>
        <!-- 인디케이터 (2개 이상일 때만) -->
        <div v-if="filteredPopupData.length > 1" class="popup-indicator">
          <span
            v-for="(item, index) in filteredPopupData"
            :key="item.id"
            :class="['dot', { active: index === currentIndex }]"
            @click.prevent="goTo(index)"
          ></span>
        </div>
      </component>

      <!-- 버튼 영역 -->
      <div class="popup-btn-wrap">
        <button type="button" class="today-btn" @click="todayClose">오늘 하루 보지 않기</button>
        <button type="button" class="close-btn" @click="close">닫기</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "PopUp",

  data() {
    return {
      currentIndex: 0,
      isVisible: true,
    };
  },

  beforeCreate() {
    this.$store.dispatch("FETCH_POPUP");
  },

  computed: {
    ...mapState({
      popupData: (state) => state.popupData,
    }),

    /**
     * 오늘 날짜가 start_day ~ end_day 기간에 포함된 팝업만 필터링
     */
    filteredPopupData() {
      if (!this.popupData || !Array.isArray(this.popupData) || this.popupData.length === 0) {
        return [];
      }

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return this.popupData.filter((item) => {
        // 날짜 포맷이 "2026.01.01" 형식일 수 있으므로 점을 하이픈으로 변환
        const startDayStr = item.start_day ? item.start_day.replace(/\./g, '-') : '';
        const endDayStr = item.end_day ? item.end_day.replace(/\./g, '-') : '';

        if (!startDayStr || !endDayStr) {
          return false;
        }

        const startDay = new Date(startDayStr);
        const endDay = new Date(endDayStr);

        // 유효하지 않은 날짜인 경우 제외
        if (isNaN(startDay.getTime()) || isNaN(endDay.getTime())) {
          return false;
        }

        startDay.setHours(0, 0, 0, 0);
        endDay.setHours(23, 59, 59, 999);

        return today >= startDay && today <= endDay;
      });
    },

    /**
     * 현재 표시할 팝업
     */
    currentPopup() {
      return this.filteredPopupData[this.currentIndex] || null;
    },
  },

  watch: {
    filteredPopupData(newVal) {
      if (this.currentIndex >= newVal.length) {
        this.currentIndex = 0;
      }
    },
  },

  mounted() {
    this.checkCookie();
  },

  methods: {
    /**
     * 팝업 닫기
     */
    close() {
      this.isVisible = false;
    },

    /**
     * 이전 팝업으로 이동
     */
    prev() {
      const length = this.filteredPopupData.length;
      this.currentIndex = (this.currentIndex - 1 + length) % length;
    },

    /**
     * 다음 팝업으로 이동
     */
    next() {
      const length = this.filteredPopupData.length;
      this.currentIndex = (this.currentIndex + 1) % length;
    },

    /**
     * 특정 인덱스로 이동
     */
    goTo(index) {
      this.currentIndex = index;
    },

    /**
     * 쿠키 설정
     */
    setCookie(name, value, hours) {
      const date = new Date();
      date.setHours(date.getHours() + hours);
      document.cookie = `${name}=${encodeURIComponent(value)}; path=/; expires=${date.toGMTString()};`;
    },

    /**
     * 쿠키 확인
     */
    checkCookie() {
      const hasCookie = document.cookie.indexOf("qcookie=done") >= 0;
      this.isVisible = !hasCookie;
    },

    /**
     * 오늘 하루 보지 않기
     */
    todayClose() {
      this.setCookie("qcookie", "done", 24);
      this.close();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/helpers/variables";
@import "~@/assets/scss/helpers/mixins";
@import "~@/assets/scss/base/typhography";

.popup {
  //position: absolute;
  //top: 50px;
  top: 100px;
  position: fixed;
  //left: 30px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1199;

  .popup-inner {
    position: relative;
    z-index: 999999;
    width: 400px;
    display: flex;
    flex-direction: column;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);

    .img-wrap {
      position: relative;
      width: 100%;
      height: 500px;
      display: block;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }

      // 화살표 버튼 공통 스타일
      .arrow-btn {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background: rgba(0, 0, 0, 0.3);
        //border: 1px solid #fff;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        backdrop-filter: blur(5px);
        z-index: 10;
        transition: background 0.2s;

        &:hover {
          background: rgba(0, 0, 0, 0.5);
        }

        .arrow-icon {
          width: 12px;
          height: 12px;
          border-bottom: 2px solid #fff;
          border-right: 2px solid #fff;
        }

        &.arrow-left {
          left: 10px;
          .arrow-prev {
            transform: rotate(135deg);
            margin-left: 4px;
          }
        }

        &.arrow-right {
          right: 10px;
          .arrow-next {
            transform: rotate(-45deg);
            margin-right: 4px;
          }
        }
      }

      // 인디케이터
      .popup-indicator {
        position: absolute;
        bottom: 15px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        gap: 8px;
        z-index: 10;

        .dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.5);
          cursor: pointer;
          transition: background 0.2s;

          &.active {
            background: #fff;
          }

          &:hover {
            background: rgba(255, 255, 255, 0.8);
          }
        }
      }
    }

    .popup-btn-wrap {
      display: table;
      width: 100%;
      height: 50px;

      button {
        display: table-cell;
        width: 50%;
        line-height: 50px;
        text-align: center;
        border: none;
        cursor: pointer;

        &.today-btn {
          background-color: $color-white;
        }

        &.close-btn {
          background-color: $color-blue;
          color: $color-white;
        }
      }
    }
  }
}

// 태블릿
@media screen and (max-width: 1024px) {
  .popup {
    left: 30px;

    .popup-inner {
      width: 350px;

      .img-wrap {
        height: 440px;

        .arrow-btn {
          width: 36px;
          height: 36px;

          .arrow-icon {
            width: 10px;
            height: 10px;
          }
        }
      }
    }
  }
}

// 모바일
@media screen and (max-width: 768px) {
  .popup {
    top: 100px;
    left: 50%;
    transform: translateX(-50%);

    .popup-inner {
      width: 90vw;
      max-width: 350px;

      .img-wrap {
        height: auto;
        aspect-ratio: 4 / 5;

        .arrow-btn {
          width: 32px;
          height: 32px;

          .arrow-icon {
            width: 8px;
            height: 8px;
          }
        }

        .popup-indicator {
          bottom: 12px;
          gap: 6px;

          .dot {
            width: 6px;
            height: 6px;
          }
        }
      }

      .popup-btn-wrap {
        height: 45px;

        button {
          line-height: 45px;
          font-size: 14px;
        }
      }
    }
  }
}
</style>
